import { onYaTag } from './yandex.tag-data';

export default async function initTags() {
  await onYaTag();
}
